'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeEvent = require('./KayleeEvent');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeEvents');

var KayleeEvents = {
    fromJson: fromJson,
    getEvents: getEvents,
};

function fromJson(data) {
    var reqProps = [ '$nodeKey' ];
    return FirebaseIndirectArray.$fromJson(data, 'Events', reqProps, reqProps,
        function(data) {
            var node = KayleeCache.get(data.$nodeKey);
            return getEvents(node, data.$limit);
        }
    );
}

function getEvents(node, limit) {
    var key = 'Events for ' + node.$nodeType + ': ' + node.$id;
    var events = KayleeCache.get(key);

    if (events === null) {
        events = new Events(node, limit);
        KayleeCache.put(key, events);
    }

    return events;
}

function Events(node, limit) {
    var path;
    var srcRef;

    this.$nodeType = 'events';
    this.$node = node;
    this.$limit = limit;

    if (node.$nodeType === 'company') {
        path = 'index/eventsByCompany/' + node.$id;
    } else if (node.$nodeType === 'site') {
        path = 'index/eventsBySite/' + node.$id;
    } else if (node.$nodeType === 'room') {
        path = 'index/eventsByRoom/' + node.$id;
    } else if (node.$nodeType === 'equipment') {
        path = 'index/eventsByEquipment/' + node.$id;
    } else if (node.$nodeType === 'controller') {
        path = 'index/eventsByController/' + node.$id;
    } else if (node.$nodeType === 'user') {
        path = 'index/eventsByUser/' + node.$id;
    } else {
        var errorMessage = 'unsupported event node type ' + node.$nodeType +
            ' for ' + node.$id;
        log.error(errorMessage);
        return Promise.reject(new Error(errorMessage));
    }

    srcRef = KayleeBase.app.database().ref(path);

    if (typeof limit !== 'undefined') {
        srcRef = srcRef.orderByKey().limitToLast(limit);
    }

    FirebaseIndirectArray.call(this, srcRef, KayleeEvent.getEvent);
    KayleeUtil.bindPrototypeMethods(Events.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

Events.prototype = Object.create(FirebaseIndirectArray.prototype);
Events.prototype.constructor = Events;

Events.prototype.$toJson = function() {
    return FirebaseIndirectArray.prototype.$toJson.call(this,
        [ '$limit' ], { $nodeKey: this.$node.$cacheKey });
};

Events.prototype.toString = function() {
    return '[Events for ' + this.$node + ']';
};

module.exports = KayleeEvents;
